import React, { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

import { useConnectors } from '../../../providers/connectors/hook/useConnectors';
import { ConfirmModal } from '../Confirm';

export const Blocker = ({ isBlocked }: { isBlocked: boolean }) => {
  const { shouldRedirect } = useConnectors();

  const isAcknowledgedBlocked = !shouldRedirect && isBlocked;

  const blocker = useBlocker(isAcknowledgedBlocked);
  const [open, setOpen] = useState(false);

  const onModalClose = () => {
    setOpen(false);
    blocker.reset?.();
  };

  const onModalConfirm = () => {
    setOpen(false);
    blocker.proceed?.();
  };

  useEffect(() => {
    if (blocker.state === 'blocked' && isAcknowledgedBlocked) {
      setOpen(true);
    }
    if (blocker.state === 'blocked' && !isAcknowledgedBlocked) {
      blocker.reset?.();
    }
  }, [blocker, setOpen]);

  useEffect(() => {
    if (!isAcknowledgedBlocked) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isAcknowledgedBlocked]);

  return (
    <ConfirmModal
      open={open}
      onClose={onModalClose}
      onConfirm={onModalConfirm}
      text="Are you sure you want to leave? All the data will be lost."
    />
  );
};
